
export default [
  {
    path: 'PgAdminCashFlow',
    name: 'PgAdminCashFlow',
    component: () => import('./PgAdminCashFlow.vue'),
    portalGroup: 'all.admin',
    meta: {
      title: 'Coins 流動'
    }
  },
  {
    path: 'PgUserCashFlow',
    name: 'PgUserCashFlow',
    component: () => import('./PgUserCashFlow.vue'),
    portalGroup: 'all.public',
    meta: {
      title: '我的金幣記錄'
    }
  }
]
